import React from 'react'

export default ({ children }) => (
  <h4 className="heading is-size-4">{children}</h4>
)
